export default __webpack_public_path__ + "static/media/5.fae1f728.png";